import React from 'react';

import get from 'lodash/get';

import { Accordion, AccordionGroup } from 'components/Accordion';
import { AGREEMENT_TYPE_INTERNAL } from 'scenes/FinancePage/IO/constants';

import BusinessPartnerContacts from './components/BusinessPartnerContacts';
import BusinessPartnerPaymentDetails from './components/BusinessPartnerPaymentDetails';
import General from './components/General';
import LegalContactPerson from './components/LegalContactPerson';
import Remarks from './components/Remarks';
import SummaryOfCertainTerms from './components/SummaryOfCertainTerms';

export default ({ data }: { data: any }) => {
  const agreementType = get(data, 'agreementType.id');

  const isShowRemarks = agreementType === AGREEMENT_TYPE_INTERNAL;
  const isShowSummary = agreementType === AGREEMENT_TYPE_INTERNAL;

  return (
    <>
      <AccordionGroup>
        <Accordion>
          <General data={data} />
        </Accordion>
        <Accordion title={'Business Partner Contacts'}>
          <BusinessPartnerContacts data={data} />
        </Accordion>
        <Accordion title={'Business Partner Payment Details'}>
          <BusinessPartnerPaymentDetails data={data} />
        </Accordion>
        <Accordion title={'Legal Contact Person'}>
          <LegalContactPerson data={data} />
        </Accordion>
        {isShowRemarks ? (
          <Accordion title={'Remarks'}>
            <Remarks data={data} />
          </Accordion>
        ) : null}
        {isShowSummary ? (
          <Accordion title={'Summary of Certain Terms'}>
            <SummaryOfCertainTerms />
          </Accordion>
        ) : null}
      </AccordionGroup>
    </>
  );
};
